import React from 'react';
import Base from './Base';
import { Link } from 'react-router-dom';
import { AuthFooter } from './AuthFooter';
import FloatingParticles from './FloatingParticles'; // مسیر را مطابق پروژه تنظیم کنید

export default class Register extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            mobile: '',
            email: '',
            fname: '',
            lname: '',
            password: '',
            nationalId: '',
            id: 0,
            code: '',
            loading: true,
            passwordFieldType: 'password'
        };
        window.document.body.classList = "nk-body bg-white npc-general pg-auth";
    }

    register(e) {
        e.preventDefault();
        if (this.isBlank(this.state.fname)) {
            this.showErorrMessage('نام خود را وارد نمایید');
            return;
        }
        if (this.isBlank(this.state.lname)) {
            this.showErorrMessage('نام خانوادگی خود را وارد نمایید');
            return;
        }
        if (this.isBlank(this.state.nationalId)) {
            this.showErorrMessage('کد ملی خود را وارد نمایید');
            return;
        }
        if (this.isBlank(this.state.mobile)) {
            this.showErorrMessage('شماره موبایل خود را وارد نمایید');
            return;
        }
        if (this.isBlank(this.state.email)) {
            this.showErorrMessage('آدرس ایمیل خود را وارد نمایید');
            return;
        }
        if (this.isBlank(this.state.password)) {
            this.showErorrMessage('کلمه عبور مد نظر خود را وارد نمایید');
            return;
        }
        this.httpPost("api/v1/register/do", {
            mobile: this.state.mobile,
            fname: this.state.fname,
            lname: this.state.lname,
            email: this.state.email,
            password: this.state.password,
            nationalId: this.state.nationalId
        })
            .then(data => {
                if (data.status === 1) {
                    this.setState({ id: data.id });
                }
                else this.showErorrMessage(data.message);
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
            });
    }

    approve(e) {
        e.preventDefault();
        if (this.isBlank(this.state.code)) {
            this.showErorrMessage('کد دریافتی از طریق پیامک را وارد نمایید');
            return;
        }
        this.httpPost("api/v1/register/approve", {
            code: this.state.code,
            id: this.state.id
        })
            .then(data => {
                if (data.status === 1) {
                    window.location.href = "/";
                }
                else this.showErorrMessage(data.message);
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
            });
    }

    componentDidMount() {
        this.httpPost("api/v1/login/get")
            .then(data => {
                if (data.logged == 1) window.location.href = "/";
                else {
                    this.setState({
                        data: data,
                        loading: false
                    });
                }
            });
    }

    changePasswordFieldType() {
        if (this.state.passwordFieldType == "password") this.setState({ passwordFieldType: "text" });
        else this.setState({ passwordFieldType: "password" });
    }

    // ========== بخش About (سمت چپ) ==========
    renderAboutPanel() {
        const siteData = this.state.data || {};
        return (
            <div className="glass-about-panel">
                <div className="glass-about-panel">
                    <div className="glass-about-inner">
                        <Link to="/" className="logo-link d-inline-block mb-4">
                            <img className="logo-light logo-img" src="/assets/images/logo2.png" alt="" />
                            <img className="logo-dark logo-img" src="/assets/images/logo2-dark.png" alt="" />
                        </Link>
                        <h2 className="about-title">{siteData.site_name || 'TAXYAR'}</h2>
                        <p className="about-desc">
                            سامانه ارسال صورت حساب مالیاتی
                          
                        </p>
                        <p className="about-desc">
                           
                            مجموعه تکسیار کلیه امور مالیاتی و مالی شما را پذیراس
                        </p>
                        <div className="about-stats">
                            <div className="stat-item">
                                <span className="stat-number">{siteData.users_count || '۱,۰۰۰+'}</span>
                                <span className="stat-label">کاربر فعال</span>
                            </div>

                        </div>
                        <div className="about-contact">
                            <span>پشتیبانی: {siteData.support_phone || '02144280118'}</span>
                            <span>_{siteData.support_phone || '02144280119'}</span>
                        </div>
                        <div className="about-contact">
                            <span> {siteData.support_phone || '09195466366'}</span>
                            <span>_{siteData.support_phone || '09357996992'}</span>
                        </div>
                        <div className="about-contact">
                            <span>آدرس : تهران ستارخان رحیمی اصل جنب اداره مالیات غرب تهران ساختمان سپهر واحد 62</span>

                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // ========== فرم ثبت‌نام (سمت راست) ==========
    renderForm() {
        return (
            <div className="nk-content">
                <div className="nk-block nk-block-middle nk-auth-body">
                    <div className="card card-bordered glass-card">
                        <div className="card-inner card-inner-lg p-0">
                            <div className="glass-split">
                                {this.renderAboutPanel()}
                                <div className="glass-form-panel">
                                    <div className="nk-block-head">
                                        <div className="nk-block-head-content">
                                            <h4 className="nk-block-title">ایجاد حساب کاربری</h4>
                                        </div>
                                    </div>
                                    <form method="post" onSubmit={e => this.register(e)}>
                                        <div className="form-group">
                                            <div className="form-label-group">
                                                <label className="form-label" htmlFor="fname">نام</label>
                                            </div>
                                            <div className="form-control-wrap">
                                                <input maxLength="100" defaultValue={this.state.fname} onChange={e => this.state.fname = e.target.value} type="text" className="form-control form-control-lg" id="fname" placeholder="نام" />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="form-label-group">
                                                <label className="form-label" htmlFor="lname">نام خانوادگی</label>
                                            </div>
                                            <div className="form-control-wrap">
                                                <input maxLength="100" defaultValue={this.state.lname} onChange={e => this.state.lname = e.target.value} type="text" className="form-control form-control-lg" id="lname" placeholder="نام خانوادگی" />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="form-label-group">
                                                <label className="form-label" htmlFor="nationalId">کد ملی</label>
                                            </div>
                                            <div className="form-control-wrap">
                                                <input maxLength="10" defaultValue={this.state.nationalId} onChange={e => this.state.nationalId = e.target.value} type="text" className="form-control form-control-lg" id="nationalId" placeholder="کد ملی" />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="form-label-group">
                                                <label className="form-label" htmlFor="mobile">شماره موبایل</label>
                                            </div>
                                            <div className="form-control-wrap">
                                                <input maxLength="11" defaultValue={this.state.mobile} onChange={e => this.state.mobile = e.target.value} type="text" className="form-control form-control-lg" id="mobile" placeholder="شماره موبایل" />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="form-label-group">
                                                <label className="form-label" htmlFor="email">آدرس ایمیل</label>
                                            </div>
                                            <div className="form-control-wrap">
                                                <input maxLength="200" defaultValue={this.state.email} onChange={e => this.state.email = e.target.value} type="text" className="form-control form-control-lg" id="email" placeholder="آدرس ایمیل" />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="form-label-group">
                                                <label className="form-label" htmlFor="password">کلمه عبور</label>
                                            </div>
                                            <div className="form-control-wrap">
                                                <a onClick={e => this.changePasswordFieldType()} className="form-icon form-icon-right passcode-switch lg hand" data-target="password">
                                                    <em className={"passcode-icon icon-" + (this.state.passwordFieldType == "password" ? "show" : "hide") + " icon ni ni-eye"}></em>
                                                    <em className={"passcode-icon icon-" + (this.state.passwordFieldType == "password" ? "hide" : "show") + " icon ni ni-eye-off"}></em>
                                                </a>
                                                <input defaultValue={this.state.password} onChange={e => this.state.password = e.target.value} type={this.state.passwordFieldType} className="form-control form-control-lg" id="password" placeholder="کلمه عبور" />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <button className="btn btn-lg btn-primary btn-block">عضویت</button>
                                        </div>
                                    </form>
                                    <div className="form-note-s2 text-center pt-4">
                                        حساب کاربری دارید؟ <Link to="/login/">ورود</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <AuthFooter Data={this.state.data} />
            </div>
        );
    }

    // ========== فرم تأیید کد (سمت راست) ==========
    renderApproveForm() {
        return (
            <div className="nk-content">
                <div className="nk-block nk-block-middle nk-auth-body">
                    <div className="card card-bordered glass-card">
                        <div className="card-inner card-inner-lg p-0">
                            <div className="glass-split">
                                {this.renderAboutPanel()}
                                <div className="glass-form-panel">
                                    <div className="nk-block-head">
                                        <div className="nk-block-head-content">
                                            <h4 className="nk-block-title">تأیید شماره موبایل</h4>
                                        </div>
                                    </div>
                                    <form method="post" onSubmit={e => this.approve(e)}>
                                        <div className="form-group">
                                            <div className="form-label-group">
                                                <label className="form-label" htmlFor="code">کد تأیید</label>
                                            </div>
                                            <div className="form-control-wrap">
                                                <input key={this.state.code} defaultValue={this.state.code} onChange={e => this.state.code = e.target.value} type="text" className="form-control form-control-lg" id="code" placeholder="کد تأیید" />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <button className="btn btn-lg btn-primary btn-block">تأیید</button>
                                        </div>
                                    </form>
                                    <div className="form-note-s2 text-center pt-4">
                                        حساب کاربری دارید؟ <Link to="/login/">ورود</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <AuthFooter Data={this.state.data} />
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? this.renderLoading() :
            this.state.id === 0 ? this.renderForm() : this.renderApproveForm();

        return (
            <div>
                {this.state.lockScreen === 1 && this.lockScreen()}
                <FloatingParticles />
                {contents}
            </div>
        );
    }
}